<ui-card>
    <app-segment-header
        title="payroll.taxForms.employeeDetails"
        [allowEdit]="taxForm().isOpen"
        (edit)="onEditEmployee.emit()"
    ></app-segment-header>

    <div class="employee-details">
        <label>{{ 'payroll.taxForms.firstName' | translate }}</label>
        <div>{{ taxForm().firstName }}</div>

        <label>{{ 'payroll.taxForms.lastName' | translate }}</label>
        <div>{{ taxForm().lastName }}</div>

        <label>{{ 'payroll.taxForms.sin' | translate }}</label>
        <div class="blur">{{ taxForm().sin }}</div>

        <label>{{ 'payroll.taxForms.address' | translate }}</label>
        <div>{{ address() }}</div>

        <label>{{ 'payroll.taxForms.provinceOfEmployment' | translate }}</label>
        <div>{{ 'provinces.' + taxForm().jurisdiction | translate }}</div>

        <label>{{ 'payroll.taxForms.applicableDateRange' | translate }}</label>
        @if (taxForm().startDate) {
            <div>{{ taxForm().startDate | appDate }} - {{ taxForm().endDate | appDate }}</div>
        } @else {
            <div>{{ taxForm().year }}</div>
        }
    </div>
</ui-card>
